module.exports = __webpack_public_path__ + "static/media/menu-background.4c9bfb5d.png";